export const sliderTablet = [
    {
        id:1,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/12/banner/tabchung-800-200-800x200.webp'
    
    },
    {
        id:2,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/12/banner/800-200-800x200-166.webp'
    
    },
    {
        id:3,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/12/banner/800-200-800x200-162.webp'
    
    },
    {
        id:4,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/12/banner/800-200-800x200-25.png'
    
    },
  
    
   
]

export const bannerTablet =[
    {
        id:1,
        title:'lorem',
        url:'https://cdn.tgdd.vn/2022/10/banner/sticky-taba8-390x97.png'
    },
    {
        id:2,
        title:'lorem',
        url:'https://cdn.tgdd.vn/2022/11/banner/ipad-9390-97-copy-390x97.png'
    }
]


export const sliderAccessories = [
    {
        id:1,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/12/banner/800-200-800x200-168.webp'
    
    },
    {
        id:2,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/11/banner/800-200-800x200-103.png'
    
    },
    {
        id:3,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/12/banner/800-200-800x200-141.webp'
    
    },
    {
        id:4,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/10/banner/800-200-800x200-86.png'
    
    },
  
    
   
]

export const bannerAccessories =[
    {
        id:1,
        title:'lorem',
        url:'https://cdn.tgdd.vn/2022/11/banner/390x97--3--390x97.png'
    },
    {
        id:2,
        title:'lorem',
        url:'https://cdn.tgdd.vn/2022/12/banner/Sticky-Flash-sale2-390x97.webp'
    }
]

export const sliderTV = [
    {
        id:1,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/12/banner/800-200-800x200-83.webp'
    
    },
    {
        id:2,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/10/banner/800x200-800x200-19.png'
    
    },
    {
        id:3,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/12/banner/800-200-800x200.webp'
    
    },
    {
        id:4,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/12/banner/800-200-800x200-144.webp'
    
    },
  
    
   
]

export const bannerTV =[
    {
        id:1,
        title:'lorem',
        url:'https://cdn.tgdd.vn/2022/06/banner/TraGop390-97-390x97-2-390x97-2.png'
    },
    {
        id:2,
        title:'lorem',
        url:'https://cdn.tgdd.vn/2022/07/banner/TV-Trung-bay-390x97-1.png'
    }
]

export const sliderPhone = [
    {
        id:1,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/12/banner/800-200-800x200-102.webp'
    
    },
    {
        id:2,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/12/banner/A96-tet-800-200-800x200.webp'
    
    },
    {
        id:3,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/12/banner/800-200-800x200-113.webp'
    
    },
    {
        id:4,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/12/banner/vivo-tet800-200-800x200.webp'
    
    },
  
    
   
]

export const bannerPhone =[
    {
        id:1,
        title:'lorem',
        url:'https://cdn.tgdd.vn/2022/12/banner/sticky-mseri3-copy2-390x97.webp'
    },
    {
        id:2,
        title:'lorem',
        url:'https://cdn.tgdd.vn/2022/12/banner/sticky-a57-copy-390x97-2.webp'
    }
]


export const sliderLaptop = [
    {
        id:1,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/12/banner/800-200-800x200-98.webp'
    
    },
    {
        id:2,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/12/banner/800-200-800x200-97.webp'
    
    },
    {
        id:3,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/11/banner/800-200-800x200-182.png'
    
    },
    {
        id:4,
        title: 'Lorem',
        url: 'https://cdn.tgdd.vn/2022/12/banner/laphp-800-200-800x200.webp'
    
    },
  
    
   
]

export const bannerLaptop =[
    {
        id:1,
        title:'lorem',
        url:'https://cdn.tgdd.vn/2022/10/banner/sticky-intel12-390x97.png'
    },
    {
        id:2,
        title:'lorem',
        url:'https://cdn.tgdd.vn/2022/12/banner/Sticky-laptop-tet-390x97.webp'
    }
]

export const groupCate = [
    {
        id:1,
        name: 'iphone',
        title:'Phụ Kiện Phone, Tablet',
        childCate:[
            {
            nameChild: 'Sạc dự phòng',
            link:'/sac-dtdd',
            imgUrl:'https://cdn.tgdd.vn/Category/57/5-Pinsa%CC%A3cdu%CC%9B%CC%A3pho%CC%80ng-100x100.png'
        },
            {
            nameChild: 'Sạc, cáp',
            link:'/sac-cap',
            imgUrl:'https://cdn.tgdd.vn/Category/9518/10-Ca%CC%81psa%CC%A3cchuye%CC%82%CC%89ndo%CC%82%CC%89i-100x100.png'
        },
            {
            nameChild: 'Ốp lưng đ.thoại',
            link:'/op-lung-flipcover',
            imgUrl:'https://cdn.tgdd.vn/Category/60/2-O%CC%82%CC%81plu%CC%9Bngdie%CC%A3%CC%82nthoa%CC%A3i-100x100.png'
        },
        {
            nameChild: 'Ốp lưng tablet',
            imgUrl:'https://cdn.tgdd.vn/Category/1662/6-O%CC%82%CC%81plu%CC%9Bngtablet-100x100.png'
        },
            {
            nameChild: 'Airtag',
            imgUrl:'https://cdn.tgdd.vn/Category/10618/airtag-100x100.png'
        },
            {
            nameChild: 'Thẻ nhớ',
            imgUrl:'https://cdn.tgdd.vn/Category/55/3-the%CC%89nho%CC%9B%CC%81-100x100.png'
        },
            {
            nameChild: 'Dán màn hình',
            imgUrl:'https://cdn.tgdd.vn/Category/1363/da%CC%81nma%CC%80nhi%CC%80nh-60x60-2.png'
        },
            {
            nameChild: 'Phụ kiện tablet',
            imgUrl:'https://cdn.tgdd.vn/Category/1882/7-Phu%CC%A3kie%CC%A3%CC%82ntablet-100x100.png'
        },
            {
            nameChild: 'Giá đỡ đ.thoại, laptop',
            imgUrl:'https://cdn.tgdd.vn/Category/6862/logogiadonew-100x100.png'
        },
            {
            nameChild: 'Gậy chụp ảnh, Gimbal',
            imgUrl:'https://cdn.tgdd.vn/Category/3885/4-Ga%CC%A3%CC%82ytu%CC%9B%CC%A3su%CC%9Bo%CC%9B%CC%81ng-100x100.png'
        },
            {
            nameChild: 'Túi chống nước',
            imgUrl:'https://cdn.tgdd.vn/Category/6859/8-Tu%CC%81icho%CC%82%CC%81ngnu%CC%9Bo%CC%9B%CC%81cdt-100x100.png'
        },
    ],
        url: "https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/accessory/tgdd/desk-phone_2.png?v=3"
    },
    {
        id:2,
        name:'laptop',
        title:'Phụ Kiện Laptop, PC',
        childCate:[
            {
                nameChild:'Sạc, cáp',
                imgUrl:'https://cdn.tgdd.vn/Category/9518/10-Ca%CC%81psa%CC%A3cchuye%CC%82%CC%89ndo%CC%82%CC%89i-100x100.png'
            },
            {
                nameChild:'Adapter sạc, chuyển đổi',
                imgUrl:'https://cdn.tgdd.vn/Category/9499/publicpreview(1)-100x100.png'
            },
            {
                nameChild:'Chuột máy tính',
                link:'/chuot-ban-phim',
                imgUrl:'https://cdn.tgdd.vn/Category/86/13-Chuo%CC%A3%CC%82tma%CC%81yti%CC%81nh-100x100.png'
            },
            {
                nameChild:'Bàn phím',
                imgUrl:'https://cdn.tgdd.vn/Category/4547/19-Ba%CC%80nphi%CC%81m-100x100.png'
            },
            {
                nameChild:'USB',
                imgUrl:'https://cdn.tgdd.vn/Category/75/14-Usb-100x100.png'
            },
            {
                nameChild:'Ổ cứng di động',
                imgUrl:'https://cdn.tgdd.vn/Category/1902/20-O%CC%82%CC%89cu%CC%9B%CC%81ngdido%CC%A3%CC%82ng-100x100.png'
            },
            {
                nameChild:'Balo, túi chống sốc',
                imgUrl:'https://cdn.tgdd.vn/Category/7923/15-Balotu%CC%81icho%CC%82%CC%81ngso%CC%82%CC%81c-100x100.png'
            },
            {
                nameChild: 'Giá đỡ đ.thoại, laptop',
                imgUrl:'https://cdn.tgdd.vn/Category/6862/logogiadonew-100x100.png'
            },
            {
                nameChild:'Phần mềm',
                imgUrl:'https://cdn.tgdd.vn/Category/85/18-Pha%CC%82%CC%80nme%CC%82%CC%80m-100x100.png'
            },
        ],
        url: "https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/accessory/tgdd/desk-lap_2.png?v=3"
    },
    {
        id:3,
        name:'headphone',
        title:'Thiết bị Âm thanh',
        childCate:[
            {
                nameChild:'Loa',
                link:'/loa-laptop',
                imgUrl:'https://cdn.tgdd.vn/Category/2162/22-Loa1-100x100.png'
            },
            {
                nameChild:'Tai nghe',
                link:'/tai-nghe',
                imgUrl:'https://cdn.tgdd.vn/Category/54/21-Tainghe-100x100.png'
            },
        ],
        url: "https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/accessory/tgdd/desk-amthanh_2.png?v=3"
    },
    {
        id:4,
        name:'tech',
        title:'Phụ Kiện Công nghệ',
        childCate:[
            {
                nameChild:'Thiết bị mạng',
                imgUrl:'https://cdn.tgdd.vn/Category/4727/16-Thie%CC%82%CC%81tbi%CC%A3ma%CC%A3ng-100x100.png'
            },
            {
                nameChild:'Thiết bi nhà thông minh',
                imgUrl:'https://cdn.tgdd.vn/Category/9458/thongminh-100x100.png'
            },
            {
                nameChild:'Camera, Webcam',
                imgUrl:'https://cdn.tgdd.vn/Category/4728/17-Camerawebcam-100x100.png'
            },
            {
                nameChild:'Khóa điện tử',
                link:'/khoa-dien-tu',
                imgUrl:'https://cdn.tgdd.vn/Category/10001/hafele-el9000-01-100x100.png'
            },
            {
                nameChild:'TV Box',
                imgUrl:'https://cdn.tgdd.vn/Category/9118/23-TVBox-100x100.png'
            },
            {
                nameChild:'Ổ cắm, bóng đèn thông minh',
                imgUrl:'https://cdn.tgdd.vn/Category/10871/logocateocam-100x100.png'
            },
            {
                nameChild:'Máy chiếu',
                imgUrl:'https://cdn.tgdd.vn/Category/862/logocatemaychieu-100x100.jpg'
            },
            {
                nameChild:'Phụ kiện ô tô',
                imgUrl:'https://cdn.tgdd.vn/Category/9041/28-Phu%CC%A3kie%CC%A3%CC%82no%CC%82to%CC%82-100x100.png'
            },
            {
                nameChild:'Máy tính cầm tay',
                imgUrl:'https://cdn.tgdd.vn/Category/9398/25-Ma%CC%81yti%CC%81nhca%CC%82%CC%80mtay-100x100.png'
            },
            {
                nameChild:'Túi đựng AirPods',
                imgUrl:'https://cdn.tgdd.vn/Category/7925/30-Tu%CC%81idu%CC%9B%CC%A3ngAirpod-100x100.png'
            },
            {
                nameChild:'Quạt mini',
                imgUrl:'https://cdn.tgdd.vn/Category/7922/29-Qua%CC%A3tmini-100x100.png'
            },
            {
                nameChild:'Pin tiểu',
                imgUrl:'https://cdn.tgdd.vn/Category/56/26-Pintie%CC%82%CC%89upindt-100x100.png'
            },
        ],
        url: "https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/accessory/tgdd/desk-congnghe_2.png?v=3"
    },
    {
        id:5,
        name:'gaming',
        title:'Phụ Kiện Gaming',
        childCate:[
            ''
        ],
        url: "https://cdn.tgdd.vn/mwgcart/mwg-site/ContentMwg/images/accessory/tgdd/desk-gaming_2.png?v=3"
    }
 
]


